import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '../modules/authentication/services';
import {AppToastrService} from '@shared/libraries/ngx-toastr/services/toastr.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private toastr: AppToastrService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((httpError: HttpErrorResponse) => {
      const { error: err = {}, status } = httpError;
      const { error } = err;

      if (status === 401) {
        this.authenticationService.softLogout();
        this.toastr.error('Twoja sesja wygasła - nastąpiło wylogowanie.');
      }

      if (status === 403) {
        this.toastr.error(error || 'Brak dostępu');
      }

      return throwError({ ...err, status });
    }));
  }
}
